import { UsuariosService } from './../../services/usuarios.service';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {ValidatorService} from '../../services/tools/validator.service';
import { AutenticacionService } from '../../services/autenticacion.service';
declare var $;

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  public usuarios: any[];
  public usuarioSelected: any;
  public permisosSelected: any[] = [];
  public allPermisos: any[];
  public allPermisosReporte: any[];
  public reportePermisos: any = [];
  public mostrarListado: any = true;
  public errors: any = {};
  public searchProcess: any;
  public searchText: string = "";
  public paginate: any = {};
  public currentPage: any = 1;
  public lastPage: any = 1;
  public processing: any = false;
  public alterTable:any = 'starting';
  public exportingCSV: any = false;
  public visibleReportes:boolean = false;
  public visibleSectionReportes:boolean = false;
  public visiblePermisos:boolean = true;
  public reportes: any = [{'acceso':'1','modulo':"reporte 1"}]

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(private usuariosService: UsuariosService, private validatorService: ValidatorService, private helperService: HelpersService, private authService: AutenticacionService) {
    this.resetUsuarioSelected = this.resetUsuarioSelected.bind(this);
    this.deleteUsuario = this.deleteUsuario.bind(this);
    this.recoveryPassword = this.recoveryPassword.bind(this);
    this.getUsuarios();
    this.getUsuariosPermisos();
  }

  ngOnInit() {
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  resetUsuarioSelected() {
    this.usuarioSelected = undefined;
    this.permisosSelected = JSON.parse(JSON.stringify( this.allPermisos ));
    this.reportePermisos = JSON.parse(JSON.stringify(this.allPermisosReporte)); 
    this.errors = {};
    this.visibleSectionReportes = true;
    this.visibleReportes = true;
  }

  startUsuarioSelected() {
    this.resetUsuarioSelected();
    this.usuarioSelected  = JSON.parse(JSON.stringify( this.usuariosService.getDefaultSchedule() ));
    this.permisosSelected = JSON.parse(JSON.stringify( this.allPermisos ));
    this.reportePermisos = JSON.parse(JSON.stringify(this.allPermisosReporte));
  }

  selectUsuario(usuario) {
    this.resetUsuarioSelected();
    const usuarioCloned = JSON.parse(JSON.stringify( usuario ));
    this.usuarioSelected = usuarioCloned;
    console.log('Usuario seleccionado:', this.usuarioSelected);
    if (this.usuarioSelected.permisos_usuarios.length > 0) {
      let permisosSelected = JSON.parse(JSON.stringify( this.usuarioSelected.permisos_usuarios ));
      let permisos = [];
      let reportes = [];
      for (let i = 0; i < permisosSelected.length; i++) {
        if(permisosSelected[i]["permisos"]["hasModule"]){
          permisosSelected[i]["hasModule"] = permisosSelected[i]["permisos"]["hasModule"];
        }
        if(permisosSelected[i]["hasModule"] == "reportes"){
          reportes.push(permisosSelected[i]);
        }else{
          //tiene permiso de sección reportes
          if(permisosSelected[i]["idPermisos"]==7 && permisosSelected[i]["lectura"]==1){
            this.visibleSectionReportes = true;
            this.visibleReportes = true;
          }
          if(permisosSelected[i]["idPermisos"]==7 && permisosSelected[i]["lectura"]==0){
            //console.log(permisosSelected[i]);
            this.visibleSectionReportes = false;
            this.visibleReportes = false;
          }
          permisos.push(permisosSelected[i]);
        }
      }
      if(permisos.length > 0){
        this.permisosSelected = JSON.parse(JSON.stringify(permisos));
      }
      if(reportes.length > 0){
        this.reportePermisos = JSON.parse(JSON.stringify(reportes));
      }
      //En caso de crear nuevos permisos, se agregan al menú que se muestra al usuario
      this.allPermisos.forEach(element => {
        let found = this.usuarioSelected.permisos_usuarios.find(el => el["idPermisos"] == element["idPermisos"]);
        if(!found){
          if(element["hasModule"] == null || (element["permisos"] && element["permisos"]["hasModule"] == null)){
            console.log("nuevo permiso encontrado: ",element);
            if(element.idPermisos == 13 || element.idPermisos == 20 || element.idPermisos == 21 || 
              element.idPermisos == 32){
              //los permisos que solo se editan tienen que tener lectura en true para poder activarse
              element.lectura = true;
              element.escritura = false;
            }else{
              element.lectura = false;
              element.escritura = false;
            }
            this.permisosSelected.push(element);
          }
        }
      });
      this.allPermisosReporte.forEach(element => {
        let found = this.usuarioSelected.permisos_usuarios.find(el => el["idPermisos"] == element["idPermisos"]);
        console.log("found: ",found);
        if(!found){
          let foundThisReporte = this.reportePermisos.find(el => el["idPermisos"] == element["idPermisos"]);
          if(!foundThisReporte){
            console.log("nuevo permiso reporte encontrado: ",element);
            if(element["hasModule"] == "reportes" || (element["permisos"] && element["permisos"]["hasModule"] == "reportes")){
              if(element["permisos"]){
                element["hasModule"] = element["permisos"]["hasModule"];
              }
              this.reportePermisos.push(element);
            }
          }
        }
      });
      console.log('this.usuarioSelected.permisos_usuarios', this.usuarioSelected.permisos_usuarios);
    } else {
      console.log("El usuario no cuenta con algún permiso")
      this.permisosSelected = JSON.parse(JSON.stringify( this.allPermisos ));
      this.reportePermisos = JSON.parse(JSON.stringify(this.allPermisosReporte));
    }
  }

  permisoLecturaChange(permiso){
    console.log("permiso:",permiso);
    if(permiso.idPermisos == 7 && permiso.lectura == 1){
      this.visibleSectionReportes = true;
      this.visibleReportes = true;
    }
    if(permiso.idPermisos == 7 && permiso.lectura == 0){
      this.visibleSectionReportes = false;
      this.visibleReportes = false;
    }
  }

  permisoEscrituraChange(permiso){
    console.log("permiso:",permiso);
    if(permiso.idPermisos == 13 && permiso.escritura == 1){
      let permisoPreautorizar = this.permisosSelected.find(el=> el.idPermisos == 21);
      permisoPreautorizar.escritura = 0;
    }
    if(permiso.idPermisos == 21 && permiso.escritura == 1){
      let permisoAutorizar = this.permisosSelected.find(el=> el.idPermisos == 13);
      permisoAutorizar.escritura = 0;
    }
  }

  SelectedUsuarioClass(usuario) {

    return (this.validatorService.required(this.usuarioSelected) && this.usuarioSelected.id === usuario.id) ? 'active' : '';
  }

  confirmRecovery(usuario) {
    if (!this.usuarioSelected && usuario) {
      this.selectUsuario(usuario);
    } 
    this.confirmModal.open({
      'title': 'Restablecer contraseña', 
      'description': '¿Está seguro que desea restablecer la contraseña del usuario ' + this.usuarioSelected.email + '?',
      'callback': this.recoveryPassword,
      'color': 'success'
    })
  }

  recoveryPassword() {
    this.usuarioSelected.restablecing = true;
    this.authService.recuperarPassword(this.usuarioSelected.email)
      .subscribe(response => {
        this.helperService.notification('Restablecer contraseña', 'Se ha enviado un correo electrónico al usuario ' + this.usuarioSelected.email +  ' para restablecer su contraseña', 'success');
        delete this.usuarioSelected.restablecing;
      }, error => {
          console.log('recoveryPassword - error ', error);
         // resuelve los errores 403 y 500
         this.helperService.httpGlobalError(error);
         delete this.usuarioSelected.restablecing;
      });
  }

  isDisabledRecovery(usuario) {
    if (!usuario || !this.usuarioSelected) {
      return false;
    }

    // el usuario actual es el seleccionado y esta restableciendo?
    return (usuario.id == this.usuarioSelected.id && this.usuarioSelected.restablecing);
  }

  getSeccionesVisibles(usuario) {
    let visibles = '';

    if (!usuario.permisos_usuarios) {
      return visibles;
    }

    let cont_permises = 0;
    usuario.permisos_usuarios.forEach((element, key, permisos) => {
      if (element.lectura == 1 ){
        if(element.idPermisos != 13 && element.idPermisos != 20 && element.idPermisos != 21 && element.idPermisos != 32)
        {//Se validan permisos que solo tienen escritura y no lectura
          if (cont_permises != 0) {
            visibles += ', ';
          }
          const modulo = (element.modulo)? element.modulo: element.permisos.modulo;
          visibles += modulo;
          cont_permises++;
        }else if((element.idPermisos == 13 && element.escritura == 1) || 
        (element.idPermisos == 20 && element.escritura == 1) || 
        (element.idPermisos == 21 && element.escritura == 1) ||
        (element.idPermisos == 32 && element.escritura == 1))
        {//Se validan permisos que solo tienen escritura y no lectura
          if (cont_permises != 0) {
            visibles += ', ';
          }
          const modulo = (element.modulo)? element.modulo: element.permisos.modulo;
          visibles += modulo;
          cont_permises++;
        }
      }
    });

    return visibles;
  }

  getUsuarios(page = null) {
    this.searchProcess = this.usuariosService.getUsuarios(page)
      .subscribe(response => {
        const content = response.json().content;
        this.usuarios = content.data;
        this.startPaginate(content);
        this.alterTable = (this.usuarios.length > 0)? false: 'not_result';
        this.searchProcess = false;
      }, error => {
        // resuelve los errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  getUsuariosPermisos() {
    this.usuariosService.getUsuariosPermisos()
      .subscribe(response => {
        const content_response = response.json().content;
        //console.log("getUsuariosPermisos content_response: ",content_response);
        let allPermisos = [];
        let allPermisosReporte = [];
        for(let i = 0; i < content_response.length; i++){
          //console.log("content_response: ",content_response[i]);
          if(content_response[i]["hasModule"] == "reportes"){
            content_response[i]["escritura"] = false;
            content_response[i]["lectura"] = false;
            allPermisosReporte.push(content_response[i]);
          }else{
            allPermisos.push(content_response[i]);
          }
        }
        console.log('#permisos', allPermisos);
        console.log('#reportePermisos', allPermisosReporte);
        allPermisos.forEach(element => {
            //Por default autorizará y no preautorizará. 
            //Asegurarse que si se agregan nuevos permisos, inicien en False
            if(element["idPermisos"] == 21){
              element["escritura"] = false;
            }else{
              element.escritura = true;
            }
            element.lectura = true;
        });
        this.allPermisos = allPermisos;
        this.allPermisosReporte = allPermisosReporte;
        //console.log('#permisos2', allPermisos);
        //console.log('allPermisos', JSON.stringify(allPermisos));
      }, error => {
        console.log('getUsuarioPermisos - error ', error);
      })
  }

  searchUsuario(page = null) {
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.searchProcess = this.usuariosService.searchUsuario(this.searchText, page)
          .subscribe(response => {
            const content = response.json().content;
            // this.resetUsuarioSelected();
            this.usuarios = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.usuarios.length > 0)? false: 'not_found';
          }, error => {
            // resuelve los errores 403 y 500
            this.helperService.httpGlobalError(error, false);
          });
    } else {
      this.getUsuarios();
    }
  }

  createUsuario() {
    if (this.validatorService.required(this.errors['inversionistas'])) {
        console.log('error en inversionista');
        return false;
    }

    this.errors = [];
    this.errors = this.usuariosService.validateUsuario(this.usuarioSelected);

    if (!$.isEmptyObject(this.errors)) {
      return false;
    }

  this.processing = true;
  console.log('pre process usuarioselected ', this.usuarioSelected);
  this.usuarioSelected.activo = (this.usuarioSelected.activo) ? 1 : 0;
  this.usuarioSelected.exportacion = (this.usuarioSelected.exportacion) ? 1 : 0;
  this.usuarioSelected.cuentas = (this.usuarioSelected.cuentas) ? 1 : 0;
  this.usuarioSelected.contador = (this.usuarioSelected.contador) ? 1 : 0;
  this.usuarioSelected.permisos_usuarios = this.permisosSelected.concat(this.reportePermisos);
  // Si se autoriza no se puede preautorizar //se comenta ya que se está validando al activar los botones
  //let autorizar = this.usuarioSelected.permisos_usuarios.find(el => el["idPermisos"] == "13");
  //let preautorizar = this.usuarioSelected.permisos_usuarios.find(el => el["idPermisos"] == "21");
  //if(autorizar && autorizar["escritura"] && preautorizar && preautorizar["escritura"]){
  //  preautorizar["escritura"] = 0;
  //}
  console.log('user to save ', this.usuarioSelected);
  
  this.usuariosService.createUsuario(this.usuarioSelected)
    .subscribe(response => {

      const respuesta = response.json();
      console.log('respuesta', respuesta);
      this.processing = false;
      if (respuesta.success) {
        this.successModal.open({
          'title': '¡Éxito!',
          'description': 'Se ha creado correctamente el usuario: ' + this.usuarioSelected.name
        });

        this.usuarioSelected.id = respuesta.content.id;
        this.goPage(1);
      }
    }, error => {
      this.processing = false;

      // resuelve los errores 403 y 500
      this.helperService.httpGlobalError(error, false);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
      }

      if (error.status == 400 || error.status == 500) {
        this.errorModal.open({
          'title': 'Error!',
          'description': 'No se ha podido guardar el usuario, inténtelo más tarde'
        });
      }
    });

}

updateUsuario() {
  if (this.validatorService.required(this.errors['inversionistas'])) {
      console.log('error en inversionista');
      return false;
  }
  this.errors = [];
  this.errors = this.usuariosService.validateUsuario(this.usuarioSelected);
  if (!$.isEmptyObject(this.errors)) {
      return false;
  }
  this.processing = true;
  console.log('pre process usuarioselected ', this.usuarioSelected);
  this.usuarioSelected.activo = (this.usuarioSelected.activo) ? 1 : 0;
  this.usuarioSelected.exportacion = (this.usuarioSelected.exportacion) ? 1 : 0;
  this.usuarioSelected.cuentas = (this.usuarioSelected.cuentas) ? 1 : 0;
  this.usuarioSelected.contador = (this.usuarioSelected.contador) ? 1 : 0;
  this.usuarioSelected.permisos_usuarios = this.permisosSelected.concat(this.reportePermisos);
  console.log('user to update ', this.usuarioSelected);

  this.usuariosService.updateUsuario(this.usuarioSelected, this.usuarioSelected.id)
    .subscribe(response => {
      const respuesta = response.json();
      this.processing = false;
      if (respuesta.success) {
        this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el usuario', 'success');
        this.goPage(this.currentPage);
      } else {
        
        this.errorModal.open({
          'title': 'Error!',
          'description': 'No se ha podido guardar el usuario, inténtelo más tarde'
        });
      }
    }, error => {
      this.processing = false;
      // resuelve los errores 403 y 500
      this.helperService.httpGlobalError(error, true);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
        this.helperService.notificationErrorDefault();
      }
    });
}

writePermission() {
  return this.usuariosService.writePermission();
}

canExport() {
  return this.usuariosService.canExport();
}

confirmDeleteUsuario() {
  this.confirmModal.open({
    'color': 'danger',
    'title': 'Eliminar usuario',
    'description': "¡ATENCIÓN! <br> Está a punto de eliminar el usuario.",
    'callback': this.deleteUsuario
  });
}

deleteUsuario() {
  this.processing = true;
  this.usuariosService.deleteUsuario(this.usuarioSelected.id)
    .subscribe(
        response => {
          const usuarioDeleted = JSON.parse(JSON.stringify( this.usuarioSelected ));
          this.processing = false;

          const modal_size = (usuarioDeleted.email.length > 30)? 'md':'sm'; // modal`s size
          
          this.successModal.open({
            'title': 'Usuario eliminado',
            'description': 'El usuario con datos: <br> Nombre: ' + usuarioDeleted.name + ' <br> Email: ' + usuarioDeleted.email + '<br> Ha sido eliminado.',
            'size': modal_size
          });
          
          if (this.authService.auth_user.id == usuarioDeleted.id) {
            this.successModal.close();
          }

          this.goPage(this.currentPage);
          this.resetUsuarioSelected();
        }, error => {
          this.processing = false;
          const content_error = error.json().content;
          // se resuelve los errores 403 y 500, no se requiere notification
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400) {
            this.errorModal.open({
              'title': 'Error',
              'description': content_error.error
            });
          }

          if (error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar el usuario, inténtelo más tarde'
            });
          }

        });
}

setBackendErrors(errors: any []) {
  let temp_errors = [];
  Object.keys(errors).forEach(function(key) {
    temp_errors[key] = errors[key][0];
  });

  this.errors = temp_errors;
}

usuarioSelectedWithId() {
  if (! this.usuarioSelected) {
    return false;
  }

  return (this.usuarioSelected.id);
}

cancelarUsuarioSelected() {
  this.confirmModal.open({
    'title': 'Cancelar Cambios',
    'description': '¿Está seguro que desea cancelar estos cambios?',
    'callback': this.resetUsuarioSelected
  });
}

exportCSV() {
    this.exportingCSV = true;
    this.usuariosService.export(this.searchText)
      .subscribe((response) => {
        this.exportingCSV = false;
      }, error => {
        // resuelve los errores 403 y 500
        this.exportingCSV = false;
        this.helperService.httpGlobalError(error, false);
      });
  }

  modalCallback(callback) {
    callback();
  }

  mainContainerClass() {
    return (this.mostrarListado) ? 'col-12' : 'offset-2 col-8';
  }

  mainTableClass() {
    return (this.mostrarListado) ? 'col-8' : 'col-4';
  }

  mainDetailsClass() {
    return (this.mostrarListado) ? 'col-4' : 'col-8';
  }

  startPaginate(content) {
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage() {
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.searchUsuario(page);
    } else {
      this.getUsuarios(page);
    }
  }

  changeSwitchListado() {
    if (!this.mostrarListado) {
      this.usuarioSelected = this.usuarioSelected.getDefaultSchedule();
    }
  }

  showReportes(){
    if(this.visibleReportes == true){
      this.visibleReportes = false;
    }
    else{
      this.visibleReportes = true;
    }
  }

  showPermisos(){
    if(this.visiblePermisos == true){
      this.visiblePermisos = false;
    }
    else{
      this.visiblePermisos = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/usuarios/usuarios.component.ts